import { MEmailSection, MEmailBlock } from '../../mdl/m-template';
import { uiSetBG } from '../../ui/bg';
import { UILabeled } from '../../ui/component/labeled';
import { UISelect } from '../../ui/component/select';
import { $el } from '../../ui/elements';
import { UIValue } from '../../ui/types';
import { $on } from '../../y/events';
import { $form } from '../../y/form';
import { YCountryId } from '../../y/types';
import { EDEditor } from '../editor';
import { EDSection } from '../section';

const section_country_values: UIValue<YCountryId | undefined>[] = [{ key: undefined, name: 'All' }, { key: 'SE', name: 'Sweden' }, { key: 'DE', name: 'Germany' }];
const bg_values: UIValue<string>[] = [{ key: '#ffffff', name: 'White' }, { key: '#ffbbea', name: 'Pink' }];

export class EmailSection<Editor extends EDEditor<MEmailSection, MEmailBlock, any>> extends EDSection<MEmailSection, MEmailBlock, any> {
    constructor(editor: Editor) {
        const background = new UISelect(bg_values, { kind: 'k-subtle' });
        const country = new UISelect(section_country_values, { kind: 'k-subtle' });

        const form = $form({ background, country });

        const properties = $el.DIV('l-form', [
            new UILabeled(background, { above: 'Background' }),
            new UILabeled(country, { above: 'Country' }),
        ]);

        super(form, editor, properties, 'c-light tl-email-section');

        $on(background, 'value', () => {
            const v = background.value || '#ffffff';
            uiSetBG(this, { color: v });
        });
    }
}
